<section class="h-full min-h-0 overflow-y-auto flex flex-col gap-2 z-0 relative p-2 lg:pl-0">
    <!-- Filters -->
    <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 shrink-0">
        <div>
            <div class="flex sm:flex-row gap-2">
                <div>
                    <div>
                        <input
                            type="text"
                            name="time"
                            id="time"
                            [(ngModel)]="todayDate"
                            [owlDateTime]="date"
                            [owlDateTimeTrigger]="date"
                            [selectMode]="'range'" />

                        <owl-date-time
                            [pickerType]="'calendar'"
                            (afterPickerClosed)="onDateChange($event)"
                            #date>
                        </owl-date-time>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex flex-col sm:flex-row gap-2">
              <div class="flex flex-col sm:flex-row gap-2">
            <div class="flex flex-col sm:flex-row gap-2 items-center">
                <div *ngIf="trips && trips.length">
                    <!-- <h1 class="text-xs text-nowrap text-left">Showing {{(50 * currentPage) - (trips != 50? (50
          -trips.length) : 0) }} entries
        </h1> -->
                </div>
                <div
                    class="inline-flex flex-wrap p-1 rounded-lg gap-0.5 bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg focus:outline-none">
                    <div [ngClass]="source === 'original' ? 'btn btn-secondary sm:text-xs/5' : 'btn-outline  dark:hover:bg-zinc-700/20 border-transparent btn-outline-secondary sm:text-xs/5'"
                        class="cursor-pointer" (click)="changeSource('original')" class="cursor-pointer">
                        Original
                    </div>
                    <div [ngClass]="source === 'fundingsource' ? 'btn btn-secondary sm:text-xs/5' : 'btn-outline  dark:hover:bg-zinc-700/20 border-transparent btn-outline-secondary sm:text-xs/5'"
                        class="cursor-pointer" (click)="changeSource('fundingsource')" class="cursor-pointer">
                        Adjusted
                    </div>
                </div>
                <select *ngIf="source === 'fundingsource'" class="w-full sm:w-36" [(ngModel)]="paymentStatus"
                    (change)="onPaymentStatusChange()">
                    <option value="">All Payments</option>
                    <option value="paid">Paid</option>
                    <option value="unpaid">Unpaid</option>
                </select>
                <select *ngIf="source === 'fundingsource'" class="w-full sm:w-40" [(ngModel)]="paymentType"
                    (change)="onPaymentTypeChange()">
                    <option value="">All Payment Types</option>
                    <option value="none">None</option>
                    <option value="manual">Manual</option>
                    <option value="square">Square</option>
                    <option value="quickbook">Quickbook</option>
                </select>
            </div>
            <button class="btn btn-secondary" (click)="generateKpiData()">
                Download
            </button>
        </div>
        </div>
    </div>

    <div class="shrink-0 overflow-x-auto">
        <h2>
            <label class="font-bold">
                Trip Statistics
            </label>
        </h2>

        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 mt-2">

            <!-- Total Scheduled -->
            <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
                <dl class="flex items-center">
                    <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                        <svg class="h-8 w-8 text-base-dark" xmlns="http://www.w3.org/2000/svg"
                            fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M6.75 3v2.25M17.25 3v2.25M3 9.75h18M5.25 5.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25A2.25 2.25 0 0 1 18.75 21H5.25A2.25 2.25 0 0 1 3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25Z" />
                        </svg>
                    </dt>

                    <dd class="w-full ml-4 truncate text-right">
                        <div class="text-xs-light truncate">
                            Total Scheduled
                        </div>
                        <div class="text-xl font-bold text-base-dark">
                            {{ kpiData?.totalScheduled || 0 }}
                        </div>
                    </dd>
                </dl>
            </div>

            <!-- Total Offered -->
            <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
                <dl class="flex items-center">
                    <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                        <svg class="h-8 w-8 text-base-dark" xmlns="http://www.w3.org/2000/svg"
                            fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M8.25 6.75h7.5M8.25 12h7.5m-7.5 5.25h7.5M5.25 3h13.5A2.25 2.25 0 0 1 21 5.25v13.5A2.25 2.25 0 0 1 18.75 21H5.25A2.25 2.25 0 0 1 3 18.75V5.25A2.25 2.25 0 0 1 5.25 3Z" />
                        </svg>
                    </dt>

                    <dd class="w-full ml-4 truncate text-right">
                        <div class="text-xs-light truncate">
                            Total Offered
                        </div>
                        <div class="text-xl font-bold text-base-dark">
                            {{ kpiData?.totalOffered || 0 }}
                        </div>
                    </dd>
                </dl>
            </div>

            <!-- Total Reroute -->
            <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
                <dl class="flex items-center">
                    <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                        <svg class="h-8 w-8 text-base-dark" xmlns="http://www.w3.org/2000/svg"
                            fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M7.5 6.75h9m0 0L13.5 3.75m3 3-3 3M16.5 17.25h-9m0 0 3 3m-3-3 3-3" />
                        </svg>
                    </dt>

                    <dd class="w-full ml-4 truncate text-right">
                        <div class="text-xs-light truncate">
                            Total Reroute
                        </div>
                        <div class="text-xl font-bold text-base-dark">
                            {{ kpiData?.totalReroute || 0 }}
                        </div>
                    </dd>
                </dl>
            </div>

            <!-- Total Onway -->
            <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
                <dl class="flex items-center">
                    <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                        <svg class="h-8 w-8 text-base-dark" xmlns="http://www.w3.org/2000/svg"
                            fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M3 13.5h13.5M16.5 13.5 19.5 10.5M16.5 13.5l3 3M5.25 18.75h1.5M17.25 18.75h1.5M5.25 10.5h9" />
                        </svg>
                    </dt>

                    <dd class="w-full ml-4 truncate text-right">
                        <div class="text-xs-light truncate">
                            Total Onway
                        </div>
                        <div class="text-xl font-bold text-base-dark">
                            {{ kpiData?.totalOnway || 0 }}
                        </div>
                    </dd>
                </dl>
            </div>

            <!-- Total Arrived -->
            <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
                <dl class="flex items-center">
                    <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                        <svg class="h-8 w-8 text-base-dark" xmlns="http://www.w3.org/2000/svg"
                            fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                        </svg>
                    </dt>

                    <dd class="w-full ml-4 truncate text-right">
                        <div class="text-xs-light truncate">
                            Total Arrived
                        </div>
                        <div class="text-xl font-bold text-base-dark">
                            {{ kpiData?.totalArrived || 0 }}
                        </div>
                    </dd>
                </dl>
            </div>

            <!-- Total Inprogress -->
            <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
                <dl class="flex items-center">
                    <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                        <svg class="h-8 w-8 text-base-dark" xmlns="http://www.w3.org/2000/svg"
                            fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M12 6v6l4 2.25M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                        </svg>
                    </dt>

                    <dd class="w-full ml-4 truncate text-right">
                        <div class="text-xs-light truncate">
                            Total Inprogress
                        </div>
                        <div class="text-xl font-bold text-base-dark">
                            {{ kpiData?.totalInprogress || 0 }}
                        </div>
                    </dd>
                </dl>
            </div>

            <!-- Total Cancelled -->
            <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
                <dl class="flex items-center">
                    <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                        <svg class="h-8 w-8 text-base-dark" xmlns="http://www.w3.org/2000/svg"
                            fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M9 9l6 6m0-6-6 6M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18Z" />
                        </svg>
                    </dt>

                    <dd class="w-full ml-4 truncate text-right">
                        <div class="text-xs-light truncate">
                            Total Cancelled
                        </div>
                        <div class="text-xl font-bold text-base-dark">
                            {{ kpiData?.totalCancelled || 0 }}
                        </div>
                    </dd>
                </dl>
            </div>

            <!-- Total Completed -->
            <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
                <dl class="flex items-center">
                    <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                        <svg class="h-8 w-8 text-base-dark" xmlns="http://www.w3.org/2000/svg"
                            fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="m9 12.75 2.25 2.25 4.5-4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                        </svg>
                    </dt>

                    <dd class="w-full ml-4 truncate text-right">
                        <div class="text-xs-light truncate">
                            Total Completed
                        </div>
                        <div class="text-xl font-bold text-base-dark">
                            {{ kpiData?.totalCompleted || 0 }}
                        </div>
                    </dd>
                </dl>
            </div>
              <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
                <dl class="flex items-center">
                    <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                    <svg class="h-8 w-8 text-base-dark" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                        stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M8.25 18.75h-1.5a2.25 2.25 0 0 1-2.25-2.25V9.75A2.25 2.25 0 0 1 6.75 7.5h10.5a2.25 2.25 0 0 1 2.25 2.25v6.75a2.25 2.25 0 0 1-2.25 2.25h-1.5M8.25 18.75a2.25 2.25 0 1 0 4.5 0m-4.5 0h4.5m4.5 0a2.25 2.25 0 1 0-4.5 0m-7.5-7.5h12M7.5 7.5l1.125-3h7.75l1.125 3M7.5 15h.008v.008H7.5V15Zm9 0h.008v.008H16.5V15Z" />
                    </svg>
                    </dt>

                    <dd class="w-full ml-4 truncate text-right">
                        <div class="text-xs-light truncate">
                            Total Trips
                        </div>
                        <div class="text-xl font-bold text-base-dark">
                            {{ kpiData?.totalTrips || 0 }}
                        </div>
                    </dd>
                </dl>
            </div>

            <!-- Total Paid -->
            <div *ngIf="source === 'fundingsource'" class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
                <dl class="flex items-center">
                    <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                        <svg class="h-8 w-8 text-base-dark" xmlns="http://www.w3.org/2000/svg" fill="none"
                            viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z" />
                        </svg>
                    </dt>

                    <dd class="w-full ml-4 truncate text-right">
                        <div class="text-xs-light truncate">
                            Total Paid
                        </div>
                        <div class="text-xl font-bold text-base-dark">
                            {{ kpiData?.totalPaid || 0 }}
                        </div>
                    </dd>
                </dl>
            </div>

            <!-- Total Unpaid -->
            <div *ngIf="source === 'fundingsource'" class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
                <dl class="flex items-center">
                    <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                        <svg class="h-8 w-8 text-base-dark" xmlns="http://www.w3.org/2000/svg" fill="none"
                            viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z" />
                        </svg>
                    </dt>

                    <dd class="w-full ml-4 truncate text-right">
                        <div class="text-xs-light truncate">
                            Total Unpaid
                        </div>
                        <div class="text-xl font-bold text-base-dark">
                            {{ kpiData?.totalUnpaid || 0 }}
                        </div>
                    </dd>
                </dl>
            </div>
        </div>


        <!-- ==================== FINANCE ==================== -->
        <h2 *ngIf="source === 'fundingsource'" class="mt-4">
            <label class="font-bold">
                Finance
            </label>
        </h2>

        <div *ngIf="source === 'fundingsource'" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 mt-2">

            <!-- Paid Amount -->
            <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
                <dl class="flex items-center">
                    <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                         <svg class="h-8 w-8 text-base-dark" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                    </dt>

                    <dd class="w-full ml-4 truncate text-right">
                        <div class="text-xs-light truncate">
                            Paid Amount
                        </div>
                        <div class="text-xl font-bold text-base-dark">
                            {{ kpiData?.paidAmount?.toFixed(2) || '0' }}
                        </div>
                    </dd>
                </dl>
            </div>

            <!-- Unpaid Amount -->
            <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
                 <dl class="flex items-center">
                    <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                         <svg class="h-8 w-8 text-base-dark" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                    </dt>

                    <dd class="w-full ml-4 truncate text-right">
                        <div class="text-xs-light truncate">
                            Unpaid Amount
                        </div>
                        <div class="text-xl font-bold text-base-dark">
                            {{ kpiData?.unpaidAmount?.toFixed(2) || '0' }}
                        </div>
                    </dd>
                </dl>
            </div>

            <!-- Total Amount -->
            <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
                 <dl class="flex items-center">
                    <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                         <svg class="h-8 w-8 text-base-dark" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                    </dt>

                    <dd class="w-full ml-4 truncate text-right">
                        <div class="text-xs-light truncate">
                            Total Amount
                        </div>
                        <div class="text-xl font-bold text-base-dark">
                            {{ kpiData?.totalAmount?.toFixed(2) || '0' }}
                        </div>
                    </dd>
                </dl>
            </div>
        </div>

        <!-- ==================== ACTUAL AMOUNT ==================== -->
        <h2 class="mt-4">
            <label class="font-bold">
                Actual Amount
            </label>
        </h2>

        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 mt-2">

            <!-- Actual FS Total -->
            <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
                <dl class="flex items-center">
                    <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                         <svg class="h-8 w-8 text-base-dark" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                    </dt>

                    <dd class="w-full ml-4 truncate text-right">
                        <div class="text-xs-light truncate">
                            Actual Total
                        </div>
                        <div class="text-xl font-bold text-base-dark">
                            {{ kpiData?.actualFSTotal?.toFixed(2) || '0' }}
                        </div>
                    </dd>
                </dl>
            </div>

   

            <!-- Effective FS Total -->
            <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
                <dl class="flex items-center">
                    <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                         <svg class="h-8 w-8 text-base-dark" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                    </dt>

                    <dd class="w-full ml-4 truncate text-right">
                        <div class="text-xs-light truncate">
                            Effective Total
                        </div>
                        <div class="text-xl font-bold text-base-dark">
                            {{ kpiData?.effectiveFSTotal?.toFixed(2) || '0' }}
                        </div>
                    </dd>
                </dl>
            </div>

        </div>


        <!-- ==================== FLAT AMOUNT ==================== -->
        <h2 class="mt-4">
            <label class="font-bold">
                Flat Amount
            </label>
        </h2>

        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 mt-2">

            <!-- Flat FS Total -->
            <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
                <dl class="flex items-center">
                    <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                         <svg class="h-8 w-8 text-base-dark" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                    </dt>

                    <dd class="w-full ml-4 truncate text-right">
                        <div class="text-xs-light truncate">
                            Flat Total
                        </div>
                        <div class="text-xl font-bold text-base-dark">
                            {{ kpiData?.flatFSTotal?.toFixed(2) || '0' }}
                        </div>
                    </dd>
                </dl>
            </div>

        

            <!-- Effective FS Total -->
            <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
                <dl class="flex items-center">
                    <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                         <svg class="h-8 w-8 text-base-dark" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                    </dt>

                    <dd class="w-full ml-4 truncate text-right">
                        <div class="text-xs-light truncate">
                            Effective  Total
                        </div>
                        <div class="text-xl font-bold text-base-dark">
                            {{ kpiData?.effectiveFSTotal?.toFixed(2) || '0' }}
                        </div>
                    </dd>
                </dl>
            </div>

        </div>

    </div>
         <div
        class="flex-1 min-h-[400px] overflow-hidden p-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
        <div class="flex-1 min-h-0 w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
            <div class="h-full w-full overflow-auto">
                <div class="min-w-max align-middle pb-6">
                    <table class="min-w-full border-separate border-spacing-0">
                        <thead>

                            <tr>

                                <th
                                    class="sticky top-0 z-20 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                                    #
                                </th>

                                <th
                                    class="sticky top-0 z-20 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                                    Funding Source
                                </th>

                                <th
                                    class="sticky top-0 z-20 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                                    Company
                                </th>

                                <th
                                    class="sticky top-0 z-20 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                                    Driver
                                </th>

                                <th
                                    class="sticky top-0 z-20 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                                    Status
                                </th>

                                <th
                                    class="sticky top-0 z-20 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                                    Reference ID
                                </th>

                                <th
                                    class="sticky top-0 z-20 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                                    Member
                                </th>

                                <th
                                    class="sticky top-0 z-20 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                                    Service Date
                                </th>

                                <th
                                    class="sticky top-0 z-20 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                                    Miles
                                </th>

                                <th
                                    class="sticky top-0 z-20 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                                    Space Type
                                </th>

                                <th
                                    class="sticky top-0 z-20 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                                    LOS
                                </th>

                                <th
                                    class="sticky top-0 z-20 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                                    Flat
                                </th>

                                <th
                                    class="sticky top-0 z-20 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                                    Actual
                                </th>

                                <th *ngIf="source === 'fundingsource'"
                                    class="sticky top-0 z-20 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                                    Payment Status
                                </th>

                                <th *ngIf="source === 'fundingsource'"
                                    class="sticky top-0 z-20 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                                    Payment Type
                                </th>

                            </tr>

                        </thead>


                        <!-- ================================================= -->
                        <!-- TABLE BODY -->
                        <!-- ================================================= -->
                        <tbody>

                            <tr *ngFor="let trip of trips; let i = index"
                                class="hover:bg-gray-950/5 dark:hover:bg-white/10">

                                <!-- # -->
                                <td
                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                                    {{ i + 1 }}
                                </td>


                                <!-- Funding Source -->
                                <td
                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">

                                    <span *ngIf="trip?.fundingsource; else noFundingSource">
                                        {{ trip.fundingsource.title | titlecase }}
                                    </span>

                                    <ng-template #noFundingSource>
                                        N/A
                                    </ng-template>

                                </td>


                                <!-- Company -->
                                <td
                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">

                                    <span *ngIf="trip?.company; else noCompany">
                                        {{ trip.company.name | titlecase }}
                                    </span>

                                    <ng-template #noCompany>
                                        N/A
                                    </ng-template>

                                </td>


                                <!-- Driver -->
                                <td
                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">

                                    {{
                                    trip?.driver?.displayName
                                    ? (trip.driver.displayName | titlecase)
                                    : 'N/A'
                                    }}

                                </td>


                                <!-- Status -->
                                <td
                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">

                                    <div class="space-x-1">

                                        <div [ngClass]="{
                                                'badge-danger':
                                                    trip?.status === 'cancelled' ||
                                                    trip?.status === 'reroute',

                                                'badge-success':
                                                    trip?.status !== 'cancelled' &&
                                                    trip?.status !== 'reroute'
                                            }">

                                            {{ trip?.status | titlecase }}

                                        </div>


                                        <ng-container *ngIf="trip?.flags && trip?.status === 'cancelled'">

                                            <span *ngIf="trip.flags.isBillable"
                                                class="inline-flex items-center gap-x-1.5 rounded-md bg-[#FEA405]/10 px-1.5 py-0.5 text-sm/5 font-medium text-[#FEA405] sm:text-xs/5">

                                                Billable

                                            </span>


                                            <span *ngIf="trip.flags.isNoShow"
                                                class="inline-flex items-center gap-x-1.5 rounded-md bg-[#FF8080]/10 px-1.5 py-0.5 text-sm/5 font-medium text-[#FF8080] sm:text-xs/5">

                                                No Show

                                            </span>

                                        </ng-container>

                                    </div>

                                </td>


                                <!-- Reference -->
                                <td
                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">

                                    {{ trip?.reference || 'N/A' }}{{ trip?.suffix ? '-' + trip.suffix : '' }}

                                </td>


                                <!-- Member -->
                                <td
                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">

                                    {{ trip?.member?.displayName | titlecase }}

                                </td>


                                <!-- Service Date -->
                                <td
                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">

                                    {{ trip?.pickup?.time | date:'MM/dd/yyyy HHmm' }}

                                </td>


                                <!-- Miles -->
                                <td
                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">

                                    {{
                                    trip?.miles
                                    ? (trip.miles | number:'1.2-2') + ' mi'
                                    : ''
                                    }}

                                </td>


                                <!-- Space Type -->
                                <td
                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">

                                    <span *ngIf="trip?.spaceType; else noSpaceType">
                                        {{ trip.spaceType.title | uppercase }}
                                    </span>

                                    <ng-template #noSpaceType>
                                        N/A
                                    </ng-template>

                                </td>


                                <!-- LOS -->
                                <td
                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">

                                    <span *ngIf="trip?.levelOfService; else noLos">
                                        {{ trip.levelOfService.title | uppercase }}
                                    </span>

                                    <ng-template #noLos>
                                        N/A
                                    </ng-template>

                                </td>


                                <td
                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">

                                    <div [ngClass]="
                                            (trip?.status === 'completed' &&
                                            trip?.specialTotal > 0) ||
                                            trip?.status === 'cancelled'
                                                ? 'line-through opacity-60'
                                                : ''
                                        ">

                                        ${{ trip?.flatFSTotal?.toFixed(2) || '0' }}

                                    </div>

                                </td>


                                <!-- Actual Company -->
                                <td
                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap font-bold bg-zinc-50 dark:bg-zinc-950">

                                    ${{ trip?.actualFSTotal?.toFixed(2) || '0' }}

                                </td>

                                <!-- Payment Status -->
                                <td *ngIf="source === 'fundingsource'"
                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                                    <div
                                        [ngClass]="{'badge-success': trip?.payment?.status === 'paid', 'badge-primary': trip?.payment?.status === 'unpaid'}">
                                        {{ (trip?.payment?.status | titlecase) || 'N/A' }}
                                    </div>
                                </td>

                                <!-- Payment Type -->
                                <td *ngIf="source === 'fundingsource'"
                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                                    {{ (trip?.payment?.relationType !== 'none' && (trip?.payment?.relationType | titlecase)) || 'N/A' }}
                                </td>


                            </tr>

                        </tbody>

                    </table>

                </div>
            </div>
        </div>
    </div>
</section>

